import keyBy from 'lodash/keyBy';
import { Logger } from 'common/logger';
import { turbineDefaults } from './helpers/turbines-model';
import { enhanceSiteTurbine } from 'common/sites';
import { getSelectedParkData } from 'common/state.helper';
import { map } from 'lodash';

const offshorePlatforms = {
    name: 'offshorePlatforms',
    state: {
        selectedPlatform: null,
        list: [],
        byId: {},
    },

    reducers: {
        updateOne(state, payload) {
            Logger.info(`Offshore data loaded for platform: ${payload.id}`);
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.id]: {
                        ...state.byId[payload.id],
                        ...payload,
                    },
                },
            };
        },
        updateAll(state, payload) {
            Logger.info('Update all Offshore data byId', payload);
            return {
                ...state,
                byId: payload,
            };
        },
        setSelectedPlatform(state, payload) {
            Logger.info(`Selected platform: ${payload.id}`);
            return {
                ...state,
                selectedPlatform: payload.id,
            };
        },
        setList(state, payload) {
            return {
                ...state,
                list: payload,
            };
        },
    },

    effects: (dispatch) => ({
        selectPlatform(payload, rootState) {
            const { selectedPlatform } = rootState.offshorePlatforms;
            if (selectedPlatform === payload.id) {
                dispatch.offshorePlatforms.deselectPlatform();
            } else {
                dispatch.offshorePlatforms.setSelectedPlatform(payload);
                dispatch.turbines.deselectTurbine();
                dispatch.logTabs.switchTabMode({ detailTabMode: true });
                dispatch.weather.setInactive();
            }
        },
        reset() {
            Logger.info('Reset offshore');
            const parkData = getSelectedParkData();

            const turbinesWithDefaults =
                parkData.platforms?.map((platformConf) => ({
                    ...turbineDefaults,
                    ...enhanceSiteTurbine(platformConf),
                })) || [];
            const allTurbinesById = keyBy(turbinesWithDefaults, (o) => o.id);
            dispatch.offshorePlatforms.updateAll(allTurbinesById);

            const platformIds = map(parkData.platforms, 'id');
            dispatch.offshorePlatforms.setList(platformIds);
        },
        deselectPlatform(_, rootState) {
            const selectedTurbine = rootState.turbines.selectedTurbine;
            dispatch.offshorePlatforms.setSelectedPlatform({ id: null });

            if (!selectedTurbine) {
                dispatch.weather.setActive();
                dispatch.logTabs.switchTabMode({ detailTabMode: false });
            }
        },
    }),
};

export default offshorePlatforms;
